import { FC } from 'react'
import type { IconProps } from '../types'

// prettier-ignore
const RefreshIcon: FC<IconProps> = ({ size = 16, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_3126_280423)'>
      <path
        d='M12.7028 6.12123C13.7492 9.21163 11.58 12.5435 8.39487 12.5435V11.1029C8.39487 10.7407 7.98241 10.5637 7.74563 10.8212L5.61457 13.0666C5.46181 13.2275 5.46181 13.477 5.61457 13.638L7.74563 15.8833C7.98241 16.1328 8.39487 15.9558 8.39487 15.6017V14.153C12.7945 14.153 15.5671 9.50135 14.1082 5.46935C13.9249 4.96234 13.2833 4.84162 12.9167 5.22792L12.8632 5.28425C12.657 5.50155 12.6112 5.82346 12.7028 6.12123Z'
        fill={color} />
      <path
        d='M3.28955 9.88679C2.26604 6.90899 4.32835 3.45635 7.60513 3.45635V4.89696C7.60513 5.25913 8.01759 5.43619 8.25437 5.17865L10.3854 2.93323C10.5382 2.77226 10.5382 2.52277 10.3854 2.36181L8.25437 0.11639C8.01759 -0.133101 7.60513 0.0439575 7.60513 0.406122V1.84673C3.20553 1.84673 0.432871 6.49854 1.89176 10.5306C2.07508 11.0377 2.71669 11.1584 3.08332 10.7721L3.14443 10.7077C3.34302 10.4984 3.38885 10.1765 3.28955 9.88679Z'
        fill={color} />
    </g>
    <defs>
      <clipPath id='clip0_3126_280423'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </svg>
)

export default RefreshIcon
